// Export for tests
export function getCoordinates(bbox, panZoomSizes) {
    return {
        x: -((bbox.x + (bbox.width / 2)) * panZoomSizes.realZoom) + (panZoomSizes.width / 2),
        y: -((bbox.y + (bbox.height /2)) * panZoomSizes.realZoom) + (panZoomSizes.height / 2)
    };
}

export default function panToElement(el, panZoomInstance, zoomLevel) {
    if (panZoomInstance && el) {
        // Zoom in to desired level, from config with default.
        panZoomInstance.zoom(zoomLevel || 5);

        // Pan to the top-left corner as coordiates are calculated form here.
        panZoomInstance.pan({x: 0, y: 0});

        // Pan to relative coordinates
        const coords = getCoordinates(el.getBBox(), panZoomInstance.getSizes())
        panZoomInstance.pan(coords);
    }
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/seatmaps/panToElement.js